module.exports = __webpack_public_path__ + "img/دفترچه-تلفن-کشی.27eb8c0b.png";